import styled from "styled-components";

export const Container = styled.div`
  /* max-width: 80vw; */
  margin-top: 50px;
  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  form > label {
    margin-top: 10px;
  }
  .inputNone {
    opacity: 0;
    width: 1px;
    /* float: right; */
    /* pointer-events: none; */
  }
  .integrationsDiv {
    background-color: #fafafa;
    border-radius: 2px;
    box-shadow: 2px 0px 10px rgba(3, 3, 3, 0.1);
    padding: 30px;
  }

  .integrationsDiv > div {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin: 20px 0px;
    flex-wrap: wrap;
  }

  .webhookIntegrations .MuiFormControl-root {
    flex: 1;
    min-width: 200px;
  }
  .errosForm {
    color: #d32f2f;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    text-align: left;
    margin-top: 3px;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0;
  }
  .advancedSettings {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 20px 0px;
  }
  .webhookContainer {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    width: 30%;
  }

  .webhookIntegrations {
    display: flex;
    flex-direction: row;
    gap: 15px;
    width: 100%;
  }
`;
